import React, { useEffect, useState } from "react";
import Header from "../general/Header";
import Aside from "../general/Aside";
import Footer from "../general/Footer";
import axios from '../../axios/axiosconf';
import { Link } from "react-router-dom";
import Loading from "../general/Loading";

function EstadisticasContables() {
    const [loggedIn, setLoggedIn] = useState(false);
    const [client, setClient] = useState([]);

    useEffect(() => {
        if (!localStorage.getItem('userdata')) {
            setLoggedIn(true);
            return;
        }

        const userdata = JSON.parse(localStorage.getItem('userdata'));

        axios.get('/get-client', {
            headers: { Authorization: 'Bearer ' + userdata.access_token }
        })
            .then(response => {
                if (response.status === 200) {
                    setClient(response.data);
                }
                setLoggedIn(true);
            })
            .catch(() => {
                setLoggedIn(true);
            });
    }, []);

    if (loggedIn) {
        return (
            <div className="wrapper hold-transition" style={{ fontSize: '13px' }}>
                <Header client={client} />
                <Aside client={client} activelink="reports" />

                <div className="content-wrapper">
                    <div className="content-header">
                        <div className="container-fluid">
                            <div className="row mb-2">
                                <div className="col-sm-12">
                                    <ol className="breadcrumb float-sm-left mb-0">
                                        <li className="breadcrumb-item"><Link to="/home">Home</Link></li>
                                        <li className="breadcrumb-item"><Link to="/estadisticas">Reportes</Link></li>
                                        <li className="breadcrumb-item active">Contables</li>
                                    </ol>
                                </div>
                            </div>
                            <div className="row mb-2 align-items-end">
                                <div className="col-md-8">
                                    <div className="dash-wrap">
                                        <h1 className="dash-title">Reportes contables</h1>
                                        <p className="dash-subtitle mb-0">Estado de cuenta, facturación, presupuestos y conciliaciones</p>
                                    </div>
                                </div>
                                <div className="col-md-4 mt-2 mt-md-0 text-md-right d-flex flex-wrap justify-content-md-end" style={{ gap: '8px' }}>
                                    <Link to="/estadisticas" className="btn btn-outline-secondary btn-sm" style={{ borderRadius: '10px', fontWeight: 600 }}>
                                        <i className="fas fa-arrow-left mr-1"></i> Volver
                                    </Link>
                                    <Link to="/home" className="btn btn-outline-secondary btn-sm" style={{ borderRadius: '10px', fontWeight: 600 }}>
                                        <i className="fas fa-home mr-1"></i> Inicio
                                    </Link>
                                </div>
                            </div>
                        </div>
                    </div>
                    <section className="content">
                        <div className="container-fluid">
                            <div className="dash-card mb-4">
                                <div className="dash-card-header">
                                    <h2 className="dash-card-title">
                                        <span className="title-icon" aria-hidden="true"><i className="fas fa-calculator"></i></span>
                                        Contables
                                    </h2>
                                </div>
                                <div className="dash-card-body">
                                    <div className="quick-grid">
                                        <Link to="/estado-cuenta-reportes" className="quick-card">
                                            <div className="quick-ico"><i className="fas fa-file-invoice-dollar"></i></div>
                                            <p className="quick-title">Estado de cuenta</p>
                                            <p className="quick-sub">Paciente o empresa</p>
                                        </Link>

                                        <Link to="/reporte-facturacion" className="quick-card">
                                            <div className="quick-ico"><i className="fas fa-file-invoice-dollar"></i></div>
                                            <p className="quick-title">Facturación</p>
                                            <p className="quick-sub">Ingresos y Facturación</p>
                                        </Link>

                                        <Link to="/reporte-notas-credito" className="quick-card">
                                            <div className="quick-ico"><i className="fas fa-file-invoice"></i></div>
                                            <p className="quick-title">Notas crédito</p>
                                            <p className="quick-sub">Electrónicas y no electrónicas</p>
                                        </Link>

                                        <Link to="/reporte-presupuestos-aprobados" className="quick-card">
                                            <div className="quick-ico"><i className="fas fa-file-signature"></i></div>
                                            <p className="quick-title">Presupuestos</p>
                                            <p className="quick-sub">Activos, anulados y pagados</p>
                                        </Link>

                                        <Link to="/libro-diario" className="quick-card">
                                            <div className="quick-ico"><i className="fas fa-book"></i></div>
                                            <p className="quick-title">Libro diario</p>
                                            <p className="quick-sub">Movimientos Contables</p>
                                        </Link>

                                        <Link to="/facturas-recibos" className="quick-card">
                                            <div className="quick-ico"><i className="fas fa-balance-scale"></i></div>
                                            <p className="quick-title">Facturas vs recibos</p>
                                            <p className="quick-sub">Conciliación</p>
                                        </Link>

                                        <Link to="/documentos-egresos" className="quick-card">
                                            <div className="quick-ico"><i className="fas fa-file-export"></i></div>
                                            <p className="quick-title">Documentos vs egresos</p>
                                            <p className="quick-sub">Egresos y Soportes</p>
                                        </Link>

                                        <Link to="/reporte-tratamientos-facturados" className="quick-card">
                                            <div className="quick-ico"><i className="fas fa-teeth"></i></div>
                                            <p className="quick-title">Tratamientos facturados</p>
                                            <p className="quick-sub">Totales por servicio</p>
                                        </Link>

                                        <Link to="/reporte-tratamientos-facturados-paciente" className="quick-card">
                                            <div className="quick-ico"><i className="fas fa-user-md"></i></div>
                                            <p className="quick-title">Tratamientos por paciente</p>
                                            <p className="quick-sub">Desglose paciente × servicio</p>
                                        </Link>

                                        <Link to="/reporte-documentos-soporte" className="quick-card">
                                            <div className="quick-ico"><i className="fas fa-file-alt"></i></div>
                                            <p className="quick-title">Documentos soporte</p>
                                            <p className="quick-sub">Listado y exportación</p>
                                        </Link>

                                        <Link to="/reporte-egresos" className="quick-card">
                                            <div className="quick-ico"><i className="fas fa-money-bill-wave"></i></div>
                                            <p className="quick-title">Egresos</p>
                                            <p className="quick-sub">Listado y exportación</p>
                                        </Link>

                                        <Link to="/exportar-siigo" className="quick-card">
                                            <div className="quick-ico"><i className="fas fa-building"></i></div>
                                            <p className="quick-title">Exportar a Siigo</p>
                                            <p className="quick-sub">Terceros, facturas y notas crédito</p>
                                        </Link>

                                        <Link to="/liquidaciones-profesional" className="quick-card">
                                            <div className="quick-ico"><i className="fas fa-hand-holding-usd"></i></div>
                                            <p className="quick-title">Liquidar profesional</p>
                                            <p className="quick-sub">Honorarios por % contratado</p>
                                        </Link>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </section>
                </div>
                <Footer showToast={false} delay={0} />
            </div>
        );
    }

    return <Loading />;
}

export default EstadisticasContables;
